export const adressTransactionTypes = {
  updatedAdress: 1,
  deleteAdress: 2,
  addAdress: 3,
};
